import { PremiumFolderType } from '../types/gallection';
import { formatDollars } from './formatting';
export function normalizePremiumFolderData(premiumFolderData) {
    var isPremiumContent = !!premiumFolderData;
    var formattedDollarPrice = formatDollars(premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.dollarPrice);
    return {
        isPremium: isPremiumContent,
        isPremiumLocked: isPremiumContent && !(premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.hasAccess),
        isPaidFolder: isPremiumContent && (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) === PremiumFolderType.Paid,
        isWatchToAccess: isPremiumContent &&
            (premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.type) === PremiumFolderType.Watchers,
        pointPrice: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.pointsPrice,
        formattedDollarPrice: formattedDollarPrice,
        folderId: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.galleryId,
        folderUrl: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.galleryUrl,
        numSubscribers: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.numSubscribers,
        subproductId: premiumFolderData === null || premiumFolderData === void 0 ? void 0 : premiumFolderData.subproductId,
    };
}
//# sourceMappingURL=normalizePremiumFolderData.js.map